import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";

//Models
import { ClientAreaUserProfile } from "./../../models/settings/client-area";
import { ClientAreaDetails } from "./../../models/settings/client-area";
import { ClientAreaUserAddress } from "./../../models/settings/client-area";
import { ClientAreaOrderDetails } from "./../../models/settings/client-area";
import { ClientAreaOrderProcessFile } from "./../../models/settings/client-area";
import { LanguageService } from "../cms/language.service";
import { CurrencyService } from "../cms/currency.service";

@Injectable()
export class ClientAreaService {
  constructor(
    public _api: ApiService, 
    public _cache: CacheService,
    private languageService: LanguageService,
    private currencyService: CurrencyService,
    private mappings: Mappings) {
  }

  getDetailsClientArea(id: string) {

    let lang = this.languageService.getLongLang();
    let url = this.mappings.Web_Api_Get_Client_Area_Details.replace('{id}', id.toString()).replace('{lang}', lang);
    let key = url;

    return this._api.getUniversalCached(url);
  }

  getUserAreaProfile(userId: string) {

    let lang = this.languageService.getLongLang();

    let url = this.mappings.Web_Api_Get_Client_Area_User_Profile.replace('{userId}', userId).replace('{lang}', lang);
    let key = url;

    return this._api.get(url);
  }

 
updateUserPassword(param: any) {

    param.Language = this.languageService.getLongLang();

    return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Password, param)
      .do(result => result)
      .share();
  }

  updateUserProfile(collection: any) {

    return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Profile, collection)
      .do(result => result)
      .share();
  }

  addNewAddress(param: any) {

    return this._api.post(this.mappings.Web_Api_Post_Client_Area_Add_New_Address, param)
      .do(result => result)
      .share();
  }

  updateAddresses(addresses: ClientAreaUserAddress[], userId: string, defaultAddress: number) {
    var param = {
      Addresses: addresses,
      UserId: userId,
      DefaultAddress: defaultAddress
    }
    return this._api.post(this.mappings.Web_Api_Post_Client_Area_Update_User_Address, param)
      .do(result => result)
      .share();
  }

  removeAddress(param: any) {
    return this._api.post(this.mappings.Web_Api_Post_Client_Area_Remove_Address, param)
      .do(result => result)
      .share();
  }

  getClientAreaOrderDetails(userId: string, orderId: number) {
    let lang: string = this.languageService.getLongLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Get_Client_Area_Order_Details.replace('{userId}', userId).replace('{orderId}', orderId.toString()).replace('{lang}', lang).replace('{currency}', curr);
    let key = url;

    return this._api.getUniversalCached(url);
  }

  getClientAreaOrdersList(userId: number, dateFrom: Date, dateTo: Date, orderNumber: string, orderStatus: string) {

    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Get_Client_Area_Order_List.replace('{userId}', userId.toString()).replace('{dateFrom}', dateFrom.toTimeString()).replace('{dateTo}', dateTo.toTimeString()).replace('{orderNumber}', orderNumber).replace('{orderStatus}', orderStatus).replace('{currency}', curr);
    let key = url;

    return this._api.get(url);
  }

    getClientAreaOrdersList1(userId: string, dateFrom: string, dateTo: string, orderNumber: string, orderStatus: string) {

    let curr = this.currencyService.getCurrency();
    let lang: string = this.languageService.getLongLang();
      
    let url = this.mappings.Web_Api_Get_Client_Area_Order_List.replace('{userId}', userId).replace('{dateFrom}', dateFrom).replace('{dateTo}', dateTo).replace('{orderNumber}', orderNumber).replace('{orderStatus}', orderStatus).replace('{lang}', lang).replace('{currency}', curr);
    let key = url;

    return this._api.getUniversalCached(url);
  }

  getClientAreaInvoicesList(userId: string, orderNumber: string, invoiceNumber: string, documentType: string) {

    let curr = this.currencyService.getCurrency();
    let lang: string = this.languageService.getLongLang();
      
    let url = this.mappings.Web_Api_Get_Client_Area_Invoices.replace('{userId}', userId).replace('{orderNumber}', orderNumber).replace('{invoiceNumber}', invoiceNumber).replace('{documentType}', documentType).replace('{lang}', lang).replace('{currency}', curr);
    let key = url;

    return this._api.getUniversalCached(url);
  }

  postClientAreaSendProcessOrderMessageint(userId: string, orderId: number, orderRowId: number, orderNumber: string, sendTo: string, messageObject: string, message: string, lang: string) {
    let url = this.mappings.Web_Api_Get_Client_Area_Order_Send_Message;

    var params = {
      UserId: userId,
      OrderId: orderId,
      OrderRowId: orderRowId,
      OrderNumber: orderNumber,
      SendTo: sendTo,
      MessageObject: messageObject,
      Message: message,
      Lang: lang
    }
    
    return this._api.post(url, params);
   }

  getProcessOrderFiles(processId: number, orderId: number) {

    let url = this.mappings.Web_Api_Get_Client_Area_Proccess_Order_File;
    var params = {
      ProcessId: processId,
      OrderId: orderId
    }

    return this._api.post(url, params);
  }

  cancelOrders(userId:string, orderId:number) {
    let url = this.mappings.Web_Api_Post_Cancel_Order.replace('{userId}', userId).replace('{orderId}', orderId.toString());
    return this._api.post(url);
  }

  updateBonificoPaymentDetails(orderId: number, numeroCro: string, numeroTrn: string) {
    let url = this.mappings.Web_Api_Get_Client_Area_Update_Bonifico_Payment
                  .replace('{orderId}', orderId.toString())
                  .replace('{numeroCro}', numeroCro)
                  .replace('{numeroTrn}', numeroTrn);
    
    return this._api.get(url);
  }

  getBonificoUploadedFiles(orderId) {
    let url = this.mappings.Web_Api_Post_Get_Bonifico_Uploaded_Files;
    var params = {
      OrderId: orderId
    }

    return this._api.post(url, params);
  }
}





// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/settings/client-area.service.ts